import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { Form, Input, InputNumber, Select, Icon, Switch, Tooltip, notification } from "antd";
import moment from "moment";
import axios from "axios";

import { useFiltros } from "../FiltrosContext";
import { GlobalContext } from "../../../../app/providers/GlobalState";

const { Option } = Select;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const FormDisciplina = ({ onClose, form }) => {
    const [registo, setRegisto] = useState({
        nome: "",
        codigo: "",
        ordem: 1
    });
    const [coordenadores, setCoordenadores] = useState([]);
    const [coordenadoresSelecionados, setCoordenadoresSelecionados] = useState([]);
    const [coordenadoresStatusField, setCoordenadoresStatusField] = useState({
        validateStatus: "",
        help: ""
    });
    const [professores, setProfessores] = useState([]);
    const [professoresSelecionados, setProfessoresSelecionados] = useState([]);
    const [professoresStatusField, setProfessoresStatusField] = useState({
        validateStatus: "",
        help: ""
    });
    const [isLoading, setIsLoading] = useState(false);

    const { turmaId, disciplinaId, setDrawerDisciplinaVisivel, triggerRefresh } = useFiltros();

    const globalContext = useContext(GlobalContext);

    const { getFieldDecorator } = form;

    const handleSubmit = e => {
        e.preventDefault();

        if (!professoresSelecionados.length) {
            setProfessoresStatusField({
                validateStatus: "error",
                help: "Deve adicionar pelo menos um professor"
            });
            return;
        }

        form.validateFields((err, values) => {
            if (!err) {
                setIsLoading(true);

                if (disciplinaId) alterarDisciplina(values);
                else criarDisciplina(values);
            }
        });
    };

    const carregarDisciplina = disciplinaId => {
        axios({
            method: "get",
            url: "/api/gestao-turmas/carregar-disciplina-ensino-especial",
            params: {
                disciplinaId
            }
        })
            .then(response => {
                const { nome, codigo, ordem, coordenadores, professores } = response.data;

                setRegisto({
                    nome,
                    codigo,
                    ordem
                });

                const coordenadoresFormatados = coordenadores.map(c => ({
                    id: c.id,
                    nome: c.nome,
                    carga_horaria: c.cargaHoraria
                }));

                setCoordenadoresSelecionados(coordenadoresFormatados);

                const professoresFormatados = professores.map(c => ({
                    id: c.id,
                    nome: c.nome,
                    carga_horaria: c.cargaHoraria
                }));

                setProfessoresSelecionados(professoresFormatados);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Ocorreu um erro!");
            });
    };

    const criarDisciplina = values => {
        var item = new FormData();
        item.append("turmaId", turmaId);
        item.append("nome", values.nome);
        item.append("codigo", values.codigo);
        item.append("ordem", values.ordem);
        if (values.coordenadores) item.append("coordenadores", JSON.stringify(values.coordenadores));

        item.append("professores", JSON.stringify(values.professores));

        axios({
            method: "post",
            url: "/api/gestao-turmas/adicionar-disciplina-ensino-especial",
            data: item
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Adicionado novo acompanhamento!");
            })
            .catch(error => {
                try {
                    openNotificationWithIcon("error", "Erro", error.response.data);
                } catch (error) {
                    openNotificationWithIcon("error", "Erro", "Ocorreu um erro!");
                }
            })
            .finally(() => {
                setIsLoading(false);
                setDrawerDisciplinaVisivel(false);
                triggerRefresh();
            });
    };

    const alterarDisciplina = values => {
        var item = new FormData();
        item.append("id", disciplinaId);
        item.append("turmaId", turmaId);
        item.append("nome", values.nome);
        item.append("codigo", values.codigo);

        if (values.coordenadores) item.append("coordenadores", JSON.stringify(values.coordenadores));

        item.append("professores", JSON.stringify(values.professores));

        axios({
            method: "put",
            url: "/api/gestao-turmas/alterar-disciplina-ensino-especial",
            data: item
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Acompanhamento editado!");
            })
            .catch(error => {
                try {
                    openNotificationWithIcon("error", "Erro", error.response.data);
                } catch (error) {
                    openNotificationWithIcon("error", "Erro", "Ocorreu um erro!");
                }
            })
            .finally(() => {
                setIsLoading(false);
                setDrawerDisciplinaVisivel(false);
                triggerRefresh();
            });
    };

    const carregarCoordenadores = () => {
        axios({
            method: "get",
            url: "/api/gestao-turmas/carregar-formadores",
            params: {
                escolaId: globalContext?.estabelecimento?.id,
                perfilId: 5
            }
        })
            .then(response => {
                setCoordenadores(response.data);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar coordenadores!");
            });
    };

    const adicionarCoordenadores = () => {
        const coordenador = {
            id: undefined
        };

        setCoordenadoresSelecionados([...coordenadoresSelecionados, coordenador]);
        setCoordenadoresStatusField({
            validateStatus: "",
            help: ""
        });
    };

    const montarCoordenadores = coordenadorId => {
        let coordenadoresIds = coordenadoresSelecionados.map(c => c.id);
        if (coordenadorId) coordenadoresIds = coordenadoresIds.filter(id => id !== coordenadorId);

        const modoEditar = false; //(cursoid > 0 && visible) || (disciplinaid > 0 && visibleDisciplina);
        const userExcluido = coordenadores.some(c => c.id === coordenadorId && c.excluido);

        return coordenadores.filter(
            c =>
                !coordenadoresIds.includes(c.id) &&
                (!modoEditar ? !c.excluido : userExcluido ? !c.excluido || c.id === coordenadorId : !c.excluido)
        );
    };

    const excluirCoordenador = index => {
        const novaLista = [...coordenadores];
        novaLista.splice(index, 1);
        setCoordenadores(novaLista);
    };

    const carregarProfessores = () => {
        axios({
            method: "get",
            url: "/api/gestao-turmas/carregar-formadores",
            params: {
                escolaId: globalContext?.estabelecimento?.id,
                perfilId: 6
            }
        })
            .then(response => {
                setProfessores(response.data);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar coordenadores!");
            });
    };

    const adicionarProfessores = () => {
        const professor = {
            id: undefined
        };

        setProfessoresSelecionados([...professoresSelecionados, professor]);
        setProfessoresStatusField({
            validateStatus: "",
            help: ""
        });
    };

    const montarProfessores = professorId => {
        let professoresIds = professoresSelecionados.map(c => c.id);
        if (professorId) professoresIds = professoresIds.filter(id => id !== professorId);

        const modoEditar = false; //(cursoid > 0 && visible) || (disciplinaid > 0 && visibleDisciplina);
        const userExcluido = professores.some(c => c.id === professorId && c.excluido);

        return professores.filter(
            c =>
                !professoresIds.includes(c.id) &&
                (!modoEditar ? !c.excluido : userExcluido ? !c.excluido || c.id === professorId : !c.excluido)
        );
    };

    const excluirProfessor = index => {
        const novaLista = [...professores];
        novaLista.splice(index, 1);
        setProfessores(novaLista);
    };

    useEffect(() => {
        carregarCoordenadores();
        carregarProfessores();

        if (disciplinaId) carregarDisciplina(disciplinaId);
    }, [disciplinaId]);

    return (
        <div className="bloco-info">
            <Form className="form-add-curso" layout="horizontal" onSubmit={handleSubmit}>
                <Form.Item label="Nome">
                    {getFieldDecorator("nome", {
                        initialValue: registo.nome,
                        rules: [
                            {
                                required: true,
                                message: "Campo obrigatório"
                            }
                        ]
                    })(<Input name="nome" />)}
                </Form.Item>
                <Form.Item label="Código">
                    {getFieldDecorator("codigo", {
                        initialValue: registo.codigo,
                        rules: [
                            {
                                required: true,
                                message: "Campo obrigatório"
                            }
                        ]
                    })(<Input name="codigo" />)}
                </Form.Item>
                <Form.Item validateStatus={coordenadoresStatusField.validateStatus} help={coordenadoresStatusField.help}>
                    <div className="bloco-fases-escolares">
                        <h3 className="titulo-separador" style={{ marginBottom: "20px" }}>
                            Coordenador(es) / Carga horaria da coordenação
                            <button className="botao-principal" type="button" onClick={adicionarCoordenadores}>
                                <Icon type="plus" />
                            </button>
                        </h3>
                        <div className="curso-lista-fases">
                            {!coordenadoresSelecionados.length ? <span>Sem dados</span> : null}
                            {coordenadoresSelecionados.map((coordenador, index) => (
                                <div key={index} className="item">
                                    <div className="item-inputs">
                                        <Form.Item>
                                            {getFieldDecorator(`coordenadores[${index}].id`, {
                                                initialValue: coordenador.id,
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "Campo obrigatório"
                                                    }
                                                ]
                                            })(
                                                <Select
                                                    showSearch
                                                    placeholder="Selecionar"
                                                    optionFilterProp="children"
                                                    onFocus={() => {}}
                                                    onBlur={() => {}}
                                                    onSearch={() => {}}
                                                    filterOption={(input, option) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {montarCoordenadores(coordenador.id).map(coordenador => (
                                                        <Option key={coordenador.id} value={coordenador.id}>
                                                            {coordenador.nome}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            )}
                                        </Form.Item>
                                        <Form.Item>
                                            {getFieldDecorator(`coordenadores[${index}].carga_horaria`, {
                                                initialValue: coordenador.carga_horaria,
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "Campo obrigatório"
                                                    }
                                                ]
                                            })(<InputNumber name={`coordenadores${index}.carga_horaria`} min={0} />)}
                                        </Form.Item>
                                    </div>
                                    <Link className="botao-icon-excluir" to="#" title="Excluir" onClick={() => excluirCoordenador(index)}>
                                        <Icon type="delete" />
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </Form.Item>
                <Form.Item validateStatus={professoresStatusField.validateStatus} help={professoresStatusField.help}>
                    <div className="bloco-fases-escolares">
                        <h3 className="titulo-separador" style={{ marginBottom: "20px" }}>
                            Professor(es) / Carga Horária
                            <button className="botao-principal" type="button" onClick={adicionarProfessores}>
                                <Icon type="plus" />
                            </button>
                        </h3>
                        <div className="curso-lista-fases">
                            {!professoresSelecionados.length ? <span>Sem dados</span> : null}
                            {professoresSelecionados.map((professor, index) => (
                                <div key={index} className="item">
                                    <div className="item-inputs">
                                        <Form.Item>
                                            {getFieldDecorator(`professores[${index}].id`, {
                                                initialValue: professor.id,
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "Campo obrigatório"
                                                    }
                                                ]
                                            })(
                                                <Select
                                                    showSearch
                                                    placeholder="Selecionar"
                                                    optionFilterProp="children"
                                                    onFocus={() => {}}
                                                    onBlur={() => {}}
                                                    onSearch={() => {}}
                                                    filterOption={(input, option) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {montarProfessores(professor.id).map(formador => (
                                                        <Option key={formador.id} value={formador.id}>
                                                            {formador.nome}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            )}
                                        </Form.Item>
                                        <Form.Item>
                                            {getFieldDecorator(`professores[${index}].carga_horaria`, {
                                                initialValue: professor.carga_horaria,
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "Campo obrigatório"
                                                    }
                                                ]
                                            })(<InputNumber name={`professores[${index}].carga_horaria`} min={0} />)}
                                        </Form.Item>
                                    </div>
                                    <Link className="botao-icon-excluir" to="#" title="Excluir" onClick={() => excluirProfessor(index)}>
                                        <Icon type="delete" />
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </Form.Item>
                <Form.Item label="Ordem">
                    {getFieldDecorator("ordem", {
                        initialValue: registo.ordem,
                        rules: [
                            {
                                required: true,
                                message: "Campo obrigatório"
                            }
                        ]
                    })(<InputNumber className="input-25" name="ordem" min={1} />)}
                </Form.Item>
                <div className="ant-drawer-footer">
                    <button
                        className="botao-secundario"
                        type="button"
                        onClick={onClose}
                        style={{ marginRight: 20, display: "inline-block" }}
                    >
                        Voltar
                    </button>
                    <button className="botao-principal" type="submit" disabled={isLoading}>
                        {isLoading ? <Icon type="loading" /> : null}
                        Salvar
                    </button>
                </div>
            </Form>
        </div>
    );
};

export default Form.create({ name: "form-acompanhamento" })(FormDisciplina);
